import { Icon, Accordion, Divider } from 'semantic-ui-react'

export interface PropsAccordionFormType {
  index: number;
  activeIndex: number;
  onClick: (e: number) => void
  editable?: boolean;
  children: any;
}

export const AccordionForm = (props: PropsAccordionFormType) => {
  const { index, activeIndex, onClick, children } = props
  const active = Boolean(activeIndex === index)
  return <>
    <Accordion.Title
      name="accord-titulo"
      active={active}
      index={index}
      onClick={(e, { index }) => onClick(active ? -1 : Number(index))}
    >
      <Divider horizontal>
        Dados do tema
        <Icon name={`chevron circle ${active ? 'down' : 'right'}`} color='grey' />
      </Divider>
    </Accordion.Title>
    <Accordion.Content active={active}>
      {children}
    </Accordion.Content>
  </>
}
